import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import Productos_db from '../../database/productos_db.json';
import styles from './Productos.module.css';

const FILTROS = ['Todos', 'Transporte', 'Comercios', 'Finanzas', 'Salud', 'Generales'];

const matchFiltro = (p, filtro) => {
  if (filtro === 'Todos') return true;
  const cat  = (p.categoria || '').toLowerCase();
  const ruta = (p.ruta      || '').toLowerCase();
  const mapa = {
    Transporte: ['colectivo', 'estacionamiento', 'autopista', 'servicio', 'tráfico', 'tren', 'subte'],
    Comercios:  ['comercio', 'farmacia', 'local', 'cine', 'veterinaria'],
    Finanzas:   ['finanz', 'banco', 'cambio', 'bolsa', 'divisa'],
    Salud:      ['salud', 'farmacia', 'veterinaria'],
    Generales:  ['text', 'turno', 'fecha', 'hora', 'temperatura', 'general'],
  };
  return (mapa[filtro] || []).some(kw => cat.includes(kw) || ruta.includes(kw));
};

export default function Productos() {
  const [todos, setTodos]       = useState([]);
  const [filtro, setFiltro]     = useState('Todos');
  const [busqueda, setBusqueda] = useState('');

  useEffect(() => {
    setTodos(Productos_db.filter(p => p.disponible));
  }, []);

  const visibles = todos.filter(p => {
    const okFiltro = matchFiltro(p, filtro);
    const q = busqueda.toLowerCase();
    const okSearch = !busqueda ||
      (p.portada?.titulo || '').toLowerCase().includes(q) ||
      (p.categoria       || '').toLowerCase().includes(q) ||
      (p.keywords || []).some(kw => kw.toLowerCase().includes(q)) ||
      (p.productos || []).some(prod =>
        (prod.nombre      || '').toLowerCase().includes(q) ||
        (prod.descripción || '').toLowerCase().includes(q)
      );
    return okFiltro && okSearch;
  });

  return (
    <>
      <Helmet>
        <title>• Catálogo Pantallas LED y Cartelería — Microled 🔴</title>
        <meta name="description" content="Catálogo completo de pantallas LED y cartelería electrónica. Cruces farmacias, turneros, colectivos, estacionamientos, finanzas y más. Fabricación nacional." />
        <meta name="theme-color" content="#CB3234" />
        <link rel="canonical" href="https://microled.com.ar/productos" />
        <meta property="og:title"       content="Catálogo Pantallas LED — Microled Argentina" />
        <meta property="og:description" content="Catálogo completo de pantallas LED y cartelería electrónica para todos los rubros." />
        <meta property="og:url"         content="https://microled.com.ar/productos" />
      </Helmet>

      {/* Banner */}
      <div className={styles.banner} style={{ backgroundImage: `url('/img/franjas/franja-productos.jpg')` }}>
        <div className={styles.bannerOverlay} />
        <div className={styles.bannerContent}>
          <p className={styles.bannerPre}>Catálogo</p>
          <h1 className={styles.bannerTitle}>Categorías de productos</h1>
          <p className={styles.bannerSub}>Fabricación a medida · Instalación incluida · Garantía 1 año</p>
        </div>
      </div>

      {/* Barra de filtros + buscador */}
      <div className={styles.toolbar}>
        <div className={styles.toolbarInner}>

          {/* Filtros como pills */}
          <div className={styles.pills}>
            {FILTROS.map(cat => {
              const n = cat === 'Todos'
                ? todos.length
                : todos.filter(p => matchFiltro(p, cat)).length;
              return (
                <button
                  key={cat}
                  className={`${styles.pill} ${filtro === cat ? styles.pillActive : ''}`}
                  onClick={() => setFiltro(cat)}
                >
                  {cat}
                  <span className={styles.pillCount}>{n}</span>
                </button>
              );
            })}
          </div>

          {/* Buscador */}
          <div className={styles.searchWrap}>
            <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8">
              <circle cx="9" cy="9" r="6"/><path d="M15 15l3 3"/>
            </svg>
            <input
              type="text"
              placeholder="Buscar producto..."
              value={busqueda}
              onChange={e => setBusqueda(e.target.value)}
            />
            {busqueda && (
              <button className={styles.clearBtn} onClick={() => setBusqueda('')}>✕</button>
            )}
          </div>
        </div>
      </div>

      {/* Grid */}
      <div className={styles.body}>
        <p className={styles.resultCount}>
          {visibles.length} categoría{visibles.length !== 1 ? 's' : ''}
          {filtro !== 'Todos' && ` · ${filtro}`}
          {busqueda && ` · "${busqueda}"`}
        </p>

        {visibles.length === 0 ? (
          <div className={styles.empty}>
            <span>🔍</span>
            <p>Sin resultados para esa búsqueda.</p>
            <button onClick={() => { setFiltro('Todos'); setBusqueda(''); }}>
              Ver todo el catálogo
            </button>
          </div>
        ) : (
          <div className={styles.grid}>
            {visibles.map(producto => (
              <Link key={producto.id} to={producto.ruta} className={styles.card}>
                <div className={styles.cardImg}>
                  <img
                    src={producto.portada.url[0]}
                    alt={producto.portada.alt[0]}
                    loading="lazy"
                  />
                  <div className={styles.cardOverlay}>
                    <span className={styles.cardTitle}>{producto.portada.titulo}</span>
                    {producto.productos?.length > 0 && (
                      <span className={styles.cardSub}>{producto.productos.length} modelo{producto.productos.length !== 1 ? 's' : ''}</span>
                    )}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </>
  );
}
